<template>
  <div v-show="store.ready" class="w-full mx-auto max-w-[400px] px-4 py-8 min-h-screen grid grid-rows-[auto_1fr_auto]">
    <ToastController />
    <div class="flex justify-center">
      <IconLogo name="logo" />
    </div>

    <div class="flex flex-col justify-center">
      <slot />
    </div>
    <div class="flex justify-center">
      <SharedFooter class="self-end" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useApplicationStore } from '~/store/application';

const store = useApplicationStore();
useHead({
  titleTemplate: titleChunk => {
    return titleChunk ? `${titleChunk} - OrderProtection` : 'Welcome - OrderProtection';
  },
});
</script>
